import React, { useCallback, useState, ReactNode, ReactElement } from "react";
import { Checkbox, message, Tooltip } from "antd";
import { ColumnsItem, JustifyContent } from "./Header";
import "./common.less";
import "./Item.less";
import InitDBService from "@/components/Joyspace/controllers/InitJoySpaceController";
import { PageType } from "@/components/Joyspace/const";
import {
  getIconUrl,
  getJoySpaceAI,
  getJoySpaceDucc,
  notUseJoySpaceOffline
} from "@/components/Joyspace/util";
import { doDrag } from "@/components/Joyspace/components/MoveDragger";
import { useNavigator } from "@/utils/NetworkCheck";
import { ContextMenuMode } from "@/components/Joyspace/types";
import JoyspaceAbstract from "../../JoyspaceAbstract";

enum Status {
  NotExistent = "0",
  Existent = "1"
}

enum FileType {
  Files = "4",
  Page = "1"
}

export interface IProps {
  item?: any;
  disabledItem?: boolean;
  columns: ColumnsItem[];
  isChecked?: boolean;
  isDisabled?: boolean;
  allowDraggble?: boolean;
  handleItem?: (columnsItem: ColumnsItem, item: any) => void;
  renderActions?: (item: any, mode?: ContextMenuMode) => ReactElement;
  preOptions?: (columnsItem: ColumnsItem, item: any, isExist: any) => ReactNode;
  afterOptions?: (columnsItem: ColumnsItem, item: any) => ReactNode;
  contentRender?: Function;
  onContextMenu?: Function;
}

const Item = (props: IProps) => {
  const {
    columns,
    renderActions,
    preOptions,
    afterOptions,
    disabledItem = false,
    isDisabled = false,
    handleItem,
    contentRender,
    isChecked,
    item: data,
    allowDraggble = false,
    onContextMenu
  } = props;
  const isExist = useNavigator.onLine || !data.page_type ? true : data.isExist;
  const setClassName = useCallback(() => {
    let className = "list-item ";
    if (!isExist) {
      // eslint-disable-next-line no-return-assign
      return (className += "list-color-grey");
    }
    if (isChecked) {
      className += "list-item-checked";
    }
    if (allowDraggble) {
      className += " draggble";
    }
    return className;
  }, [isChecked, allowDraggble, isExist]);

  return (
    <div
      onContextMenu={() => {
        onContextMenu?.();
      }}
      className={setClassName()}
      data-drag={
        // @ts-ignore
        allowDraggble && !("page_type" in data) ? data.id : "stop"
      }
      onDragStart={(e) => {
        if (!allowDraggble) {
          message.info("当前位置不支持拖拽");
          e.preventDefault();
          return;
        }
        // @ts-ignore
        const dragImage = e.target?.querySelector?.(".joyspace-list-td-title") || e.target;
        doDrag({ dragItem: data, e, dragImage, dragFrom: "table" });
      }}
      draggable
    >
      {/* {isExist} */}
      {!isExist && <div className="list-item-disabled" />}
      {columns?.map((item: ColumnsItem) => {
        return (
          <div
            className={`joyspace-list-td ${item.ellipsis ? "joyspace-list-ellipsis" : ""} ${
              item.key === "title" ? "joyspace-list-td-title" : ""
            }`}
            style={{
              position: "relative",
              width: item.width || "auto",
              justifyContent: (item as any).justifyContent || JustifyContent.Left,
              flex: item.width && "initial",
              ...item.style
            }}
            key={item.key}
          >
            {getJoySpaceAI() && item.key === "title" && <JoyspaceAbstract item={data} />}
            <span
              className={item.key === "title" ? "img-span" : ""}
              onClick={() => {
                handleItem?.(item, data);
              }}
            >
              {preOptions?.(item, data, !isExist)}
            </span>
            {item.checkbox ? (
              <Checkbox
                value={data[item.dataIndex]}
                disabled={isDisabled && !notUseJoySpaceOffline()}
              />
            ) : item.actions ? (
              renderActions?.(data)
            ) : (
              contentRender?.(item, data) || (
                <Tooltip placement="top" title={item.ellipsis ? data[item.dataIndex] : ""}>
                  <span
                    className={
                      item.key === "title"
                        ? "joyspace-list-title joyspace-list-ellipsis "
                        : item.ellipsis
                        ? "joyspace-list-text joyspace-list-ellipsis "
                        : "joyspace-list-text"
                    }
                    // title={item.ellipsis ? data[item.dataIndex] : ''}
                    onClick={() => {
                      handleItem?.(item, data);
                    }}
                  >
                    {data[item.dataIndex]}
                  </span>
                </Tooltip>
              )
            )}
            {afterOptions?.(item, data)}
          </div>
        );
      })}
    </div>
  );
};

export default Item;
